import { render, staticRenderFns } from "./article-tracker.vue?vue&type=template&id=1b840a60&scoped=true"
import script from "./article-tracker.vue?vue&type=script&lang=js"
export * from "./article-tracker.vue?vue&type=script&lang=js"
import style0 from "./article-tracker.vue?vue&type=style&index=0&id=1b840a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b840a60",
  null
  
)

export default component.exports